import {SCHEME} from '@zzng/common/constants/scheme';
import {isRequiredKakaoTalkVersionForHome} from '@zzng/common/scheme/digitalcard';
import {isKakaoTalk} from '@zzng/common/utils/agent';
import {appendQueryParamToUrl} from '@zzng/common/utils/common';
import {executeAppScheme} from '@zzng/common/utils/scheme';

/**
 * 11.2.0에 추가된 inappbrowser 스킴 파라미터
 * 1) 안드로이드 > no_multi
 * - 인앱브라우저 분리 옵션(default: false)
 * 2) 안드로이드 > should_domain_check
 * - 내부 도메인 허용 옵션(default: false)
 * - false인 경우 외부 도메인도 허용함
 * - 클라이언트에 11.2.0 이상 버전부터는 클라이언트에 강제로 박혀있음
 * - https://jira.daumkakao.com/browse/CARD-632
 */
export const openInappbrowser = (url: string) => {
  if (!isKakaoTalk) {
    // iOS Safari에서 setTimeout으로 래핑해야 동작
    setTimeout(() => window.open(url, '_blank'));
    return;
  }

  // 여러 페이즈 톡 설치 유저 && 인앱브라우저 분리 옵션이 켜져있는 경우 화면이 닫히지 않는 이슈 대응
  const schemeUrl = appendQueryParamToUrl(SCHEME.INAPPBROWSER, {
    url,
    no_multi: true,
    should_domain_check: !isRequiredKakaoTalkVersionForHome ? false : undefined
  });
  executeAppScheme(schemeUrl, true);
};
